import { RouteName } from '@mews-commander/enums';
import { useResolveRoute } from '@mews/routing';
import { lt } from '@mews/framework';
import { SuspenseBoundary } from '@mews-commander/ui';
import { WithEnterpriseId } from '@mews-commander/types';
import { Container, Stack } from '@optimus-web/core';
import { useEnterprise } from '@mews-commander/legacy-entities/src/enterprise';
import { BaseLayout } from '../../../components/layout';
import { Breadcrumbs } from '../../../components/BreadcrumbList';
import { GoLiveCard } from './GoLiveCard';
import { GoLiveLastChange } from './GoLiveLastChange';

export const GoLiveContainer = ({ enterpriseId }: WithEnterpriseId) => {
    const { name } = useEnterprise(enterpriseId);
    const resolveRoute = useResolveRoute();
    const enterpriseUrl = resolveRoute(RouteName.EnterpriseDetail, { enterpriseId });

    const breadcrumbs: Breadcrumbs = [
        { url: enterpriseUrl, text: name },
        { active: true, text: lt('OnboardingGoLiveContainerBreadcrumb') },
    ];

    return (
        <BaseLayout breadcrumbs={breadcrumbs} padded>
            <SuspenseBoundary>
                <Container maxWidth="640px">
                    <Stack vertical spacing="400">
                        <GoLiveCard enterpriseId={enterpriseId} />
                        <GoLiveLastChange enterpriseId={enterpriseId} />
                    </Stack>
                </Container>
            </SuspenseBoundary>
        </BaseLayout>
    );
};
